document.addEventListener('DOMContentLoaded', () => {
  const blogContent = document.querySelector('.article-template__content');
  if (!blogContent) return;

  // 1. まず記事内のテキストをスキャンして、[PROD:handle] を探す
  const walker = document.createTreeWalker(blogContent, NodeFilter.SHOW_TEXT, null, false);
  const nodesToReplace = [];

  while (walker.nextNode()) {
    if (walker.currentNode.textContent.match(/\[PROD:([\w-]+)\]/)) {
      nodesToReplace.push(walker.currentNode);
    }
  }

  // 2. 見つかったテキストノードを一つずつ「本物のDOM要素」に置き換える
  nodesToReplace.forEach(node => {
    const text = node.textContent;
    const regex = /\[PROD:([\w-]+)\]/g;
    let match;
    
    // 同一テキストノード内に複数のショートコードがある場合も考慮
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;

    while ((match = regex.exec(text)) !== null) {
      // ショートコードより前のテキストを追加
      fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
      
      // 商品カードのコンテナを作成
      const handle = match[1];
      const container = document.createElement('div');
      container.className = 'js-custom-product-card';
      container.dataset.handle = handle;
      container.innerHTML = '<div class="spinner">Loading...</div>'; // 読み込み中表示
      
      fragment.appendChild(container);
      lastIndex = regex.lastIndex;

      // データのフェッチを開始
      fetchProductData(handle, container);
    }
    // 残りのテキストを追加
    fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
    
    // 元のテキストを、構築したフラグメント（テキスト+カード）に差し替え
    node.parentNode.replaceChild(fragment, node);
  });
});

// 商品データを取得してHTMLを書き換える関数
async function fetchProductData(handle, container) {
  try {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) throw new Error('Product not found');
    const product = await response.json();
    
    // 価格のフォーマット（日本円想定）
    const price = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(product.price / 100);

    container.innerHTML = `
      <div class="shortcode-product-card">
        <a href="${product.url}" class="card-link">
          <div class="shortcode-product-card__image">
            <img src="${product.featured_image}" alt="${product.title}" loading="lazy" width="300">
          </div>
          <div class="shortcode-product-card__info">
            <span class="vendor">${product.vendor}</span>
            <h3 class="title">${product.title}</h3>
            <span class="price">${price}</span>
          </div>
        </a>
      </div>
    `;
  } catch (err) {
    console.error(`Error loading product (${handle}):`, err);
    container.remove(); // 失敗したら要素ごと消す
  }
}